import styled from 'styled-components';
import { SHELL_BOTTOM_CLEARANCE } from 'spark-views/common/header/navigationBarConfig';

const Canvas = styled.div`
    margin: 0;
    padding: 24px 24px ${SHELL_BOTTOM_CLEARANCE}px;
    box-sizing: border-box;
`;

export default Canvas;
